/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1000
 */

var r = require(/* 727 */"../../../../797/101/2466/2467/727/index")
var i = require(/* 538 */"../../../../797/101/2466/2467/538")
module.exports = function (e) {
  return "symbol" == typeof e || i(e) && "[object Symbol]" == r(e)
}
